import $ from 'jquery';


export default (selector, hash) => {

    $(window).on('load', function () {

        let newsletter_anchor = $(selector);

        let anchor = window.location.hash;

        if (window.location.hash === hash) {

            $("html, body").delay(1000).animate({
                scrollTop: newsletter_anchor.offset().top - 100
            }, 1000);
        }

        console.log(anchor);

    });

};



// WEBPACK FOOTER //
// ./scripts/libs/anchor_link.js